export default __webpack_public_path__ + "static/media/postmanC.84a3f94f.webp";